import { FC } from "react";
import { Helmet } from "react-helmet";

export const SignupCompletePage: FC = () => {
  return <>
    <Helmet>
      <title>アカウント登録完了</title>
      <meta name="description" content="アカウント登録完了" />
    </Helmet>
    <div className="mt-4 text-base sm:text-lg font-bold">アカウントとFreeプランの登録が完了しました。</div>
    <div className="mt-1 text-sm text-gray-500">Drop AIを使った画像生成の世界をお楽しみください！</div>
  </>;
}